import { TableV2 } from '@anytag/shared-atoms';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { TwitterAnalyticsPostItemPayload } from '@anytag/graphql';
import { InfluencerTwitterAnalyticsPostDetailsModal } from '@anytag/shared-molecules';
import { useInfluencerTwitterPostsListTable } from './hooks';

export interface InfluencerTwitterPostsListProps extends TableData<TwitterAnalyticsPostItemPayload> {
  mainSocialAccountId?: number;
}

export const InfluencerTwitterPostsList = ({
  loading,
  data = [],
  mainSocialAccountId
}: InfluencerTwitterPostsListProps) => {
  const { columns } = useInfluencerTwitterPostsListTable();

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} rowHeight="62px" noTopBorderRadius hasBorder />

      <InfluencerTwitterAnalyticsPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId }))}
      />
    </>
  );
};
